import { Sponsor, SponsorRequest } from "./dto/Sponsors";


// clients/imageClient.ts
export const imageClient = {
  /**
   * Fetch images matching a pattern
   * @param pattern - Glob pattern like "sponsor_*.jpg"
   */
  getImages: async (pattern: string): Promise<string[]> => {
    const response = await fetch(
      `/api/media/images?name=${encodeURIComponent(pattern)}`
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch images: ${response.statusText}`);
    }
    return response.json();
  },

  /**
   * Upload an image
   * @param filename - Name to save the file as (e.g., "sponsor_acme.jpg")
   * @param file - The image file
   */
  uploadImage: async (filename: string, file: File): Promise<void> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(
      `/api/media/images/${encodeURIComponent(filename)}`,
      {
        method: 'POST',
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to upload image: ${response.statusText}`);
    }
  },

  /**
   * Delete an image
   * @param filename - Name of the file to delete
   */
  deleteImage: async (filename: string): Promise<void> => {
    const response = await fetch(
      `/api/media/images/${encodeURIComponent(filename)}`,
      {
        method: 'DELETE',
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to delete image: ${response.statusText}`);
    }
  },

  /**
   * Get the full URL for an image (served by Nginx)
   * @param filename - Name of the image file
   */
  getImageUrl: (filename: string): string => {
    return `/media/images/${encodeURIComponent(filename)}`;
  },
};


export const sponsorClient = {
  /**
   * Create a new sponsor
   */
  createSponsor: async (sponsor: SponsorRequest): Promise<Sponsor> => {
    const response = await fetch(`/api/sponsors`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(sponsor),
    });

    if (!response.ok) {
      throw new Error(`Failed to create sponsor: ${response.statusText}`);
    }

    return response.json();
  },

  /**
   * Fetch a single sponsor
   */
  getSponsors: async (): Promise<Array<Sponsor>> => {
    const response = await fetch(`/api/sponsors`);

    if (!response.ok) {
      throw new Error(`Failed to fetch sponsor: ${response.statusText}`);
    }

    return response.json();
  },

  /**
   * Update a sponsor
   */
  updateSponsor: async (id: number, sponsor: Partial<SponsorRequest>): Promise<Sponsor> => {
    const response = await fetch(`/api/sponsors/${id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(sponsor),
    });

    if (!response.ok) {
      throw new Error(`Failed to update sponsor: ${response.statusText}`);
    }

    return response.json();
  },

  /**
   * Delete a sponsor
   */
  deleteSponsor: async (id: number): Promise<void> => {
    const response = await fetch(`/api/sponsors/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error(`Failed to delete sponsor: ${response.statusText}`);
    }
  },
};

export default function notUsed() {

}
